import { createAction } from '@reduxjs/toolkit';
import type { SavedSearch, SearchParameters } from 'lib-search-types';

const prefix = 'search';

export const searchActions = {
  params: {
    update: createAction<Partial<SearchParameters<'conversations'>>>(
      `${prefix}/params/update`,
    ),
  },

  savedSearch: {
    apply: createAction<SavedSearch>(`${prefix}/savedSearch/apply`),
    /** Closes the active saved search and resets the search params. */
    close: createAction(`${prefix}/savedSearch/close`),
    /** Unsets the active saved search while keeping the current params. */
    unset: createAction(`${prefix}/savedSearch/unset`),
  },
};
